// -----------------------------------------------------------
import React from 'react';
// -----------------------------------------------------------

const riskResults = [
	{
		title: 'Safety First',
		explanation: [
			<p key="p1" className="results-section__card-explanation">
				You don’t like surprises, meaning volatility. You want things planned
				out. You have little tolerance for risk or potential loss. While it’s
				important that you grow your assets, it’s also important that you limit
				your risk exposure.
			</p>,
			<p key="p2" className="results-section__card-explanation">
				You may want to work with a financial professional to develop a strategy
				that will have low levels of volatility. You also may want to consider
				tools like annuities, which can provide growth potential with downside
				protection.
			</p>
		],
		picRef: '/Tools/rqanalyzerform/icons/results/risk-averse.png',
		rqDetail: '(R.Q. 1-20)'
	},
	{
		title: 'Somewhat Conservative',
		explanation: [
			<p key="p1" className="results-section__card-explanation">
				You’re practical. You’re careful, but not too careful. You’d like to
				avoid risk, but you also understand that some level of risk may be
				necessary to achieve growth. Consider developing a strategy that
				minimizes risk exposure while also providing growth opportunities. Tools
				like annuities may be able to help you achieve that objective.
			</p>
		],
		picRef: '/Tools/rqanalyzerform/icons/results/somewhat-conservative.png',
		rqDetail: '(R.Q. 21-40)'
	},
	{
		title: 'Perfect Balance',
		explanation: [
			<p key="p1" className="results-section__card-explanation">
				You’re neither aggressive nor conservative, but both — you’re whatever
				the situation calls for. You have perfect harmony between the need for
				growth and the need to limit your exposure. You’re centered, so to
				speak.
			</p>,
			<p key="p2" className="results-section__card-explanation">
				You may want to work with a financial professional to develop a strategy
				that combines growth-focused strategies with low levels of volatility
				(e.g., annuities, which can provide growth potential with downside
				protection).
			</p>
		],
		picRef: '/Tools/rqanalyzerform/icons/results/balanced.png',
		rqDetail: '(R.Q. 41-60)'
	},
	{
		title: 'Moderately Aggressive',
		explanation: [
			<p key="p1" className="results-section__card-explanation">
				You might be able to accept some risk in your life. You’re more focused
				on growth potential than downside loss, so you’re willing to accept
				above-average risk levels. A financial professional could help you
				develop a strategy that has the potential to meet your growth targets.
			</p>
		],
		picRef: '/Tools/rqanalyzerform/icons/results/moderately-aggressive.png',
		rqDetail: '(R.Q. 61-80)'
	},
	{
		title: 'Risk-Taker',
		explanation: [
			<p key="p1" className="results-section__card-explanation">
				All bets are on. Your priority is to aggressively grow your assets, with
				little regard for downside volatility. You understand the short-term
				fluctuations that occur in the market and aren’t phased by downturns. A
				financial professional can help you implement an allocation that
				maximizes your growth opportunities.
			</p>
		],
		picRef: '/Tools/rqanalyzerform/icons/results/aggressive.png',
		rqDetail: '(R.Q. 81-100)'
	}
];

const disclaimer = {
	disclaimer1:
		'Licensed Insurance Professional. This information is designed to provide a general overview regarding the subject matter covered and is not state specific. The authors, publisher and host are not providing legal, accounting, or specific advice for your situation. By providing your information, you give consent to be contacted about the possible sale of an insurance or annuity product. This information has been provided by a Licensed Insurance Professional and does not necessarily represent the views of the presenting insurance professional. The statements and opinion expressed are those of the author and are subject to change at any time. All information is believed to be from reliable sources; however, presenting insurance professional makes no representation as to its completeness or accuracy. This material has been prepared for informational and educational purposes only. It is not intended to provide, and should not be relied upon for, accounting, legal, tax or investment advice.',
	disclaimer2: '17646 - 2018/5/15'
};

export default function resultsReturn(number) {
	if (number >= 1 && number <= 20) {
		return { ...riskResults[0], ...disclaimer };
	} else if (number >= 21 && number <= 40) {
		return { ...riskResults[1], ...disclaimer };
	} else if (number >= 41 && number <= 60) {
		return { ...riskResults[2], ...disclaimer };
	} else if (number >= 61 && number <= 80) {
		return { ...riskResults[3], ...disclaimer };
	} else if (number >= 81) {
		return { ...riskResults[4], ...disclaimer };
	}
}



// WEBPACK FOOTER //
// ./src/data/rqResults.js